import ClassicQuizRankFilters from "./ClassicQuizRankFilters";

export default class ClassicQuizLeaderboardFilters extends ClassicQuizRankFilters {
  classicQuizIds?: string[] = null;

  constructor(filters) {
    super(filters);
    this.classicQuizIds = filters?.classicQuizIds || null;
  }

  public constructMainFiltersUrl?(): string {
    let url = super.constructMainFiltersUrl();

    if (this.classicQuizIds && this.classicQuizIds.length > 0) {
      url += `&classic_quiz_ids=${this.classicQuizIds.join(",")}`;
    }

    return url;
  }
}
